module.exports = __webpack_public_path__ + "img/c99cff7.svg";